import { useCallback, useEffect, useState } from "react";
import { PppoeUserService } from "../services/PppoeUserService";

export const useHookPppoeUserDetail = ({ id: id }) => {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await PppoeUserService.show({ id: id });
            setData(res?.data?.data);
        } catch (err) {
            console.error(err);
            setError(err?.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        loading,
        error,

        refreshData: getData,
    };
};